module.exports = __webpack_public_path__ + "static/media/uy.d5c02111.svg";